import InputText from '../../AlgoliaArticles/FilterBar/InputText'
import Image from 'next/legacy/image'

import css from './styles.module.scss'
import classnames from 'classnames/bind'

const cx = classnames.bind(css)

const SearchInputWithButton = ({
  fullSearch,
  onSearchChange,
  toggleFilters,
}) => {
  return (
    <div className={css.searchWrapper}>
      <InputText
        className={cx(css.searchP, { full: fullSearch })}
        aria-label="search blog post"
        onChange={onSearchChange}
        placeholder="Search"
        icon="search"
      />
      <button
        className={css.filterBtn}
        theme="white"
        onClick={toggleFilters}
        as="button"
        type="button"
      >
        <Image src="/assets/filter-icon.svg" width={16} height={16} />
      </button>
    </div>
  )
}

export default SearchInputWithButton
